var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-element",style:(_vm.entityStyle),on:{"mouseover":_vm.setStyle,"mouseout":_vm.unsetStyle}},[_vm._v(" "+_vm._s(_vm.entity.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }